import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_DELIVERY_POINT_RESET = 'PUT_DELIVERY_POINT_RESET';
export const PUT_DELIVERY_POINT_LOADING = 'PUT_DELIVERY_POINT_LOADING';
export const PUT_DELIVERY_POINT_SUCCESS = 'PUT_DELIVERY_POINT_SUCCESS';
export const PUT_DELIVERY_POINT_REJECT = 'PUT_DELIVERY_POINT_REJECT';

//* ACTIONS ------------------------------------------------
export const putDeliveryPointReset = () => ({ type: PUT_DELIVERY_POINT_RESET });
export const putDeliveryPointLoading = () => ({ type: PUT_DELIVERY_POINT_LOADING });
export const putDeliveryPointSuccess = (payload) => ({ type: PUT_DELIVERY_POINT_SUCCESS, payload });
export const putDeliveryPointReject = (payload) => ({ type: PUT_DELIVERY_POINT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putDeliveryPointRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data: {
            idDeliveryPoint: data.deliveryPointIdPut,
            deliveryName: data.deliveryName,
            deliveryCode: data.deliveryCode,
            description: data.description,
            address: data.address,
            contactName: data.contactName,
            contactPhone: data.contactPhone,
            contactEmail: data.contactEmail,
            latitude: data.latitude,
            longitude: data.longitude,
            idUser: data.idUser,
            isActive: data.isActive,
            muniId: data.muniId,
        },
    }, getState);
    return request(`/DeliveryPoints/web/UpdateDeliveryPoints`, options);
};


